import { Check } from "lucide-react";
import { landingContent } from "../../data/landingContent";
import { SearchHandleForm } from "./SearchHandleForm";

export function FinalCTA() {
  const { finalCta } = landingContent;

  return (
    <section id="final-cta" className="st-section" style={{ background: "#FFF" }}>
      <div className="st-container">
        <div className="st-final-cta-inner st-reveal" style={{ textAlign: "center" }}>
          <h2 className="st-heading-2" style={{ marginBottom: "12px" }}>
            {finalCta.title}
          </h2>
          <p className="st-body-large" style={{ maxWidth: "580px", margin: "0 auto 28px" }}>
            {finalCta.subtitle}
          </p>

          <div className="st-search-wrapper" style={{ margin: "0 auto" }}>
            <SearchHandleForm
              placeholder={finalCta.inputPlaceholder}
              ctaLabel={finalCta.ctaLabel}
              typewriterExamples={[]}
            />

            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "8px", marginTop: "18px" }}>
              {finalCta.trustBullets.map((bullet, index) => (
                <span
                  key={index}
                  style={{
                    background: "rgba(255,107,138,0.06)",
                    border: "1px solid rgba(255,107,138,0.12)",
                    padding: "5px 12px",
                    fontSize: "0.8125rem",
                    fontWeight: 700,
                    borderRadius: "99px",
                    color: "var(--pink-primary)",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <Check size={12} strokeWidth={3} />
                  {bullet}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );

}
